import React, { useEffect, useState } from "react";
import { getAllGeneralLedger } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import OpeningSideBar from "../openingSideBar/openingSIdeBar";
import Example from "./calling.js";
import "./party.css";
import {
  getAllParty,
  createAccount,
  updateSingleAccount,
  deleteSingleAccount,
} from "../../api/endpoints/party";
const { Option } = Select;

const Party = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    ledgerCodes: [],
    glCode: "",
    glDescription: "",
    parties: [],
    partyId: "",
    partyName: "",
    address: "",
    fullName: "",
    phone: "",
    email: "",
    partyType: "",
    billType: "",
    billTime: "",
    billSummary: "",
    unBilledBalence: "",
    billedBalence: "",
    description: "",
    bChrages: "",
    closed: "",
    suspended: "",
    NTNNO: "",
    saleTaxRNo: "",
  });

  const clearState = () => {
    setState({
      id: "",
      ledgerCodes: state.ledgerCodes,
      parties: state.parties,
      partyId: "",
      partyName: "",
      glCode: "",
    fullName: "",
      glDescription: "",
      address: "",
      phone: "",
      email: "",
      partyType: "",
      billType: "",
      billTime: "",
      billSummary: "",
      unBilledBalence: "",
      billedBalence: "",
      description: "",
      closed: "",
          NTNNO: "",
    saleTaxRNo: "",
      suspended: "",
    });
    setItemsQueue([]);
  };

  console.log(state, "Vall");

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
    setState({
      ...state,
      billTime: "Monthly",
      partyType: "Customer",
      billType: "Vehicle Wise",
      closed: 0,
    });
  };
  //   console.log(state.generalLedgerCode.length,"leng")
  const saveTank = async (e) => {
    if (
      !state.partyId ||
      !state.partyName ||
      !state.glCode ||
      !state.glDescription ||
      !state.partyType
    ) {
      return message.error(
        `Please type ${
          !state.glCode
            ? "General Ledger Code"
            : !state.glDescription
              ? "Gl Description"
              : !state.partyId
                ? "Account Number"
                : !state.partyName
                  ? "Party Name"
                  : !state.partyType
                    ? "Party Type"
                    : ""
        }`,
      );
    }

    const payload = {
      partyId: state.partyId,
      partyName: state.partyName,
      address: state.address,
      phone: state.phone,
      email: state.email,
      partyType: state.partyType,
      billType: state.billType,
      NTNNO: state.NTNNO,
      saleTaxRNo: state.saleTaxRNo,
      fullName: state.fullName,
      billTime: state.billTime,
      bChrages: Number(state.bChrages),
      generalLedgerCode: Number(state.glCode),
      closed: Number(state.closed),
      grpId: Number(user.grpId),
      siteId: Number(user.siteId),
      companyCode: Number(user.companyCode),
    };

    console.log(payload, "payload");

    const results = await createAccount(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.partyId ||
        !state.partyName ||
        !state.glCode ||
        !state.glDescription ||
        !state.partyType
      ) {
        return message.error(
          `Please type ${
            !state.glCode
              ? "General Ledger Code"
              : !state.glDescription
                ? "Gl Description"
                : !state.partyId
                  ? "Account Number"
                  : !state.partyName
                    ? "Party Name"
                    : !state.partyType
                      ? "Party Type"
                      : ""
          }`,
        );
      }
      const data = {
        id: state.id,
        partyId: state.partyId,
        partyName: state.partyName,
        address: state.address,
        phone: state.phone,
        email: state.email,
        NTNNO: state.NTNNO,
      fullName: state.fullName,
        saleTaxRNo: state.saleTaxRNo,
        partyType: state.partyType,
        billType: state.billType,
        billTime: state.billTime,
        bChrages: Number(state.bChrages),
        generalLedgerCode: Number(state.glCode),
        closed: Number(state.closed),
      };
      console.log(data, "edite data");
      const results = await updateSingleAccount(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.partyId) return message.error("Please Select Account");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Account?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      partyId: state.partyId,
    };
    const results = await deleteSingleAccount(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Account?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _parties = await getAllParty(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editHandler = async (e) => {
    const results = await getAllParty(access_token);

    const payload = results.reduce((acc, curr) => {
      return [
        ...acc,
        {
          partyId: curr.partyId,
          partyName: curr.partyName,
          generalLedgerCode: curr.generalLedgerCode,
          description: curr.chartOfAccount.description,
        },
      ];
    }, []);

    setItemsQueue(payload);
  };

  return (
    <>
      {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && <Example item={itemsQueue} />}
          </div>
          <div className="pb-3 flex justify-center">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              onClick={clearState}
            >
              Exit
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex bg-black main">
            <OpeningSideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <div className="flex justify-center">
                <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className="text-white">Add Party Account</h1>
                    {contextHolder}
                  </div>
                  <div className="p-2 flex justify-center">
                    {fieldsShow && (
                      <div className="w-70">
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Account Number:
                            </label>
                            {type === "EDIT" || type === "DELETE" ? (
                              <>
                                <Select
                                  className="bg-black text-slate-400 inpTxt  h-8 w-full"
                                  showSearch
                                  placeholder=""
                                  optionFilterProp="children"
                                  value={state.partyId || ""}
                                  onChange={(e) => {
                                    const _accountInfo = state.parties.find(
                                      (el) => el.partyId === e,
                                    );
                                    console.log("e", _accountInfo);

                                    setState({
                                      ...state,
                                      partyId: e,
                                      id: _accountInfo.id,
                                      partyName: _accountInfo.partyName,
                                      glCode: _accountInfo.generalLedgerCode,
                                      glDescription:
                                        _accountInfo.chartOfAccount.description,
                                      address: _accountInfo.address,
                                      phone: _accountInfo.phone,
                                      NTNNO: _accountInfo.NTNNO,
                                      saleTaxRNo: _accountInfo.saleTaxRNo,
                                      email: _accountInfo.email,
                                      partyType: _accountInfo.partyType,
                                      billType: _accountInfo.billType,
                                      billTime: _accountInfo.billTime,
                                      fullName: _accountInfo.fullName,
                                      billSummary: _accountInfo.billSummary,
                                      closed: _accountInfo.closed,
                                      bChrages: _accountInfo.bChrages,
                                    });
                                  }}
                                >
                                  {state.parties.map((el) => (
                                    // console.log(el, "el")
                                    <Option value={el.partyId}>
                                      {`${el.partyId} - ${el.partyName}`}
                                    </Option>
                                  ))}
                                </Select>
                              </>
                            ) : (
                              <input
                                type="number"
                                name="partyId"
                                value={state.partyId}
                                onChange={onChangeText}
                                className="bg-black text-slate-400  inpTxt h-8 w-full"
                              />
                            )}
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Name :
                            </label>
                            <input
                              type="text"
                              name="partyName"
                              value={state.partyName}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Phone :
                            </label>
                            <input
                              type="text"
                              name="phone"
                              value={state.phone}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Email :
                            </label>
                            <input
                              type="email"
                              name="email"
                              value={state.email}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              NTN :
                            </label>
                            <input
                              type="text"
                              name="NTNNO"
                              value={state.NTNNO}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Sale Tax Retrun No :
                            </label>
                            <input
                              type="text"
                              name="saleTaxRNo"
                              value={state.saleTaxRNo}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Address :
                            </label>
                            <input
                              type="text"
                              name="address"
                              value={state.address}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Bill Time :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full ml-3"
                              placeholder=""
                              optionFilterProp="children"
                              value={state.billTime || "Monthly"} // Set to "Monthly" if state.billTime is falsy
                              onChange={(value) => {
                                onChangeText({
                                  target: { name: "billTime", value },
                                });
                              }}
                            >
                              <Option value={"Monthly"} name="billTime">
                                Monthly
                              </Option>
                              <Option value={"Fortnightly"} name="billTime">
                                Fortnightly
                              </Option>
                            </Select>
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white " htmlFor="fname">
                              Party Type :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full"
                              placeholder="No"
                              optionFilterProp="children"
                              value={state.partyType || "Customer"}
                              onChange={(value) =>
                                onChangeText({
                                  target: { name: "partyType", value },
                                })
                              }
                            >
                              <Option value={"Customer"} name="partyType">
                                Customer
                              </Option>
                              <Option value={"Card"} name="partyType">
                                Card
                              </Option>
                              <Option value={"Supplier"} name="partyType">
                                Supplier
                              </Option>
                              <Option value={"Miscellaneous"} name="partyType">
                                Miscellaneous
                              </Option>
                              <Option value={"Employee"} name="partyType">
                                Employee
                              </Option>
                            </Select>
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Bill Type :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full ml-3"
                              placeholder="No"
                              optionFilterProp="children"
                              value={state.billType || "Vehicle Wise"}
                              onChange={(value) =>
                                onChangeText({
                                  target: { name: "billType", value },
                                })
                              }
                            >
                              <Option value={"Customer Wise"} name="billType">
                                Customer Wise
                              </Option>
                              <Option value={"Vehicle Wise"} name="billType">
                                Vehicle Wise
                              </Option>
                            </Select>
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              GL Description :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full"
                              placeholder="GL Description"
                              optionFilterProp="children"
                              value={state.glDescription || "GL Description "}
                              onChange={(e) => {
                                const lCode = state.ledgerCodes.find(
                                  (el) => el.generalLedgerCode === e,
                                );
                                setState({
                                  ...state,
                                  glCode: e,
                                  glDescription: lCode.description,
                                });
                              }}
                            >
                              {state.ledgerCodes.map((el) => (
                                <Option value={el.generalLedgerCode}>
                                  {el.description}
                                </Option>
                              ))}
                            </Select>
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              GL Code :
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full ml-3"
                              placeholder="Credit GL Code"
                              optionFilterProp="children"
                              value={state.glCode || "Credit GL Code"}
                              onChange={(e) => {
                                const lCode = state.ledgerCodes.find(
                                  (el) => el.generalLedgerCode === e,
                                );
                                setState({
                                  ...state,
                                  glCode: e,
                                  glDescription: lCode.description,
                                });
                              }}
                            >
                              {state.ledgerCodes.map((el) => (
                                <Option value={el.generalLedgerCode}>
                                  {el.generalLedgerCode}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Closed:
                            </label>
                            <Select
                              showSearch
                              className="text-black inpTxt  h-9 w-full"
                              placeholder="No"
                              optionFilterProp="children"
                              value={state.closed === "" ? "No" : state.closed}
                              onChange={(value) =>
                                onChangeText({
                                  target: { name: "closed", value },
                                })
                              }
                            >
                              <Option value={0} name="closed">
                                No
                              </Option>
                              <Option value={1} name="closed">
                                Yes
                              </Option>
                            </Select>
                          </div>
                          <div className="w-1/2 mb-3">
                            <label className="text-white ml-3" htmlFor="fname">
                              Bank Charges :
                            </label>
                            <input
                              type="number"
                              name="bChrages"
                              value={state.bChrages}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 ml-3 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                        </div>
                        <div className="flex justify-evenly w-full">
                          <div className="w-1/2 mb-3">
                            <label className="text-white" htmlFor="fname">
                              Full Name :
                            </label>
                            <input
                              type="text"
                              name="fullName"
                              value={state.fullName}
                              onChange={onChangeText}
                              className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                            />
                          </div>
                          
                        </div>
                      </div>
                    )}
                  </div>
                  <div class="flex justify-center pb-3">
                    {type === "ADD" && (
                      <button
                        onClick={addTank}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillFileAdd className="mr-2 mt-1" />

                        <span>Add</span>
                      </button>
                    )}

                    {type === "SAVE" && (
                      <button
                        onClick={saveTank}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillSave className="mt-1 mr-2 " />
                        <span>Save</span>
                      </button>
                    )}
                    {type === "ADD" && (
                      <button
                        onClick={editHandler}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded"
                      >
                        <LuView className="mt-1 mr-2 " />
                        <span>View</span>
                      </button>
                    )}
                    {type === "ADD" && (
                      <button
                        onClick={editTank}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillEdit className="mr-2 mt-1" />

                        <span>Edit</span>
                      </button>
                    )}

                    {(type === "EDIT" || type === "DELETE") && (
                      <button
                        onClick={saveEditTank}
                        className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                      >
                        DONE
                      </button>
                    )}
                    {type === "ADD" && (
                      <button
                        onClick={confirmDelete}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillDelete className="mr-2 mt-1" />

                        <span>Delete</span>
                      </button>
                    )}
                    {type !== "ADD" && (
                      <button
                        onClick={clearStates}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <BiExit className="mr-2 mt-1" />
                        <span>Exit</span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Party;
